export var ETimeDifferenceUnit;
(function (ETimeDifferenceUnit) {
    ETimeDifferenceUnit["MILLISECOND"] = "MILLISECOND";
    ETimeDifferenceUnit["SECOND"] = "SECOND";
    ETimeDifferenceUnit["MINUTE"] = "MINUTE";
    ETimeDifferenceUnit["HOUR"] = "HOUR";
    ETimeDifferenceUnit["DAY"] = "DAY";
    ETimeDifferenceUnit["WEEK"] = "WEEK";
    ETimeDifferenceUnit["MONTH"] = "MONTH";
    ETimeDifferenceUnit["HALF_YEAR"] = "HALF_YEAR";
    ETimeDifferenceUnit["YEAR"] = "YEAR";
})(ETimeDifferenceUnit || (ETimeDifferenceUnit = {}));
